import React, { Suspense } from "react";
import { lazy } from "react";
import { Routes, Route } from "react-router-dom";
import { Spin } from "antd";
////LAZY LOADING PAGES////
const LandingPage = lazy(() => import("../pages/landingPage/LandingPage"));
const About = lazy(() => import("../pages/about/About"));
const Pricing = lazy(() => import("../pages/pricing/Pricing"));
const BookDemo = lazy(() => import("../pages/bookDemo/BookDemo"));
const Contact = lazy(()=> import("../pages/contact/Contact"))
const ComingSoon = lazy(() => import("../components/ComingSoon"));

const RouteIndex = () => {
  const Loader = () => (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <Spin size="large" style={{ color: "#F15F2C" }} />
    </div>
  );
  return (
    <Routes>
      <Route
        path="/landingPage"
        element={
          <Suspense fallback={<Loader />}>
            <LandingPage />
          </Suspense>
        }
      />
      <Route
        path="/about"
        element={
          <Suspense fallback={<Loader />}>
            <About />
          </Suspense>
        }
      />
      <Route
        path="/pricing"
        element={
          <Suspense fallback={<Loader />}>
            <Pricing />
          </Suspense>
        }
      />
      <Route
        path="/bookDemo"
        element={
          <Suspense fallback={<Loader />}>
            <BookDemo />
          </Suspense>
        }
      />
      <Route
      path="/contact"
      element={
        <Suspense fallback={<Loader/>}>
          <Contact/>
        </Suspense>
      }/>
      <Route
        path="/"
        element={
          <Suspense fallback={<Loader />}>
            <ComingSoon />
          </Suspense>
        }
      />
    </Routes>
  );
};

export default RouteIndex;
